import { RetryStrategy } from './retry.strategy'

export const retryBackoffStrategy: (
  backoffAttemptsInMs: number[]
) => RetryStrategy = (backoffAttemptsInMs: number[]) => {
  return {
    run: async <T>(
      fn: () => Promise<T> | T,
      logFailedAttempt: (attempt: number, error: unknown) => void = () => {}
    ): Promise<T> => {
      let lastError: unknown
      let attempt = 0
      let maxAttempts = backoffAttemptsInMs.length

      for await (const { timeoutMs, totalBackoffMs } of backoffAttemptsIterator(
        backoffAttemptsInMs
      )) {
        attempt++
        try {
          return await fn()
        } catch (error) {
          lastError = new Error(
            `Failed attempt number ${attempt}, waited for: ${timeoutMs}, total backoff time: ${totalBackoffMs}ms `,
            {
              cause: error,
            }
          )
          /*                                              */
          if (attempt < maxAttempts) {
            logFailedAttempt(attempt, error)
          }
        }
      }
      throw new Error(
        `Failed to execute function after max attempts of ${attempt}.`,
        {
          cause: lastError!,
        }
      )
    },
  }
}

async function* backoffAttemptsIterator(backOfAttemptsInMs: number[]) {
  let totalBackoffMs = 0
  for (const timeoutMs of backOfAttemptsInMs) {
    totalBackoffMs += timeoutMs
    if (timeoutMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, timeoutMs))
    }
    yield { timeoutMs, totalBackoffMs }
  }
}
